import { Integrator } from "./Integrator";
import { UFL } from "./UFL";

export class Common {
    /**
   * @returns {import("../types").DialogState}
  */
    static associateIrrigationZoneDialog(t, data, irrigationZones) {
        const currentSelection = data.connection_data?.config?.sector_id_riego;
        return {
            visible: true,
            activeStep: 0,
            data: {
                irrigationZones,
                sector_id_riego: currentSelection
            },
            oldData: {},
            resolveBody: (values, props) => {
                const body = {
                    sector_id: data.connection_data?.config?.sector_id,
                    sector_id_riego: values.sector_id_riego,
                    external_provider_id: data.connection_data?.external_provider_id
                };
                return { url: `/external/${props.farmId}/set-irrigation-zone`, body };
            },
            skipCostStep: true,
            skipReviewStep: true,
            hideStepper: true,
            confirmButtonLabel: t("general.confirm"),
            steps: [
                {
                    label: t("external.associateIrrigation"),
                    inputs: [
                        {
                            label: t("external.associateIrrigation"),
                            campo: "sector_id_riego",
                            component: "select",
                            optionsName: "irrigationZones",
                            optionKey: "sector_id",
                            optionLabel: "nombre",
                            optionGroupChildren: "zones",
                            optionGroupLabel: "equipo",
                            showClear: true
                        },
                    ],
                },
            ],
        };
    }

    /**
   * @returns {import("../types").DialogState}
  */
    static disconnectDialog(t, data, farmId) {
        return {
            visible: true,
            activeStep: 0,
            data: {},
            nombre_servicio: t("sass.desconectar"),
            oldData: {},
            resolveBody: () => {
                let url, body;
                switch (data.tipo_formulario) {
                    case "REQUEST":
                        url = `/marketplace/${farmId}/cancel-request`;
                        body = { marketplace_request_id: data.connection_data?.marketplace_request_id };
                        break;
                    case "FEATURE":
                        url = `/marketplace/${farmId}/disable-feature`;
                        body = { feature: data.otras_configuraciones.key };
                        break;
                    case "API_SDB":
                        url = `/farms/${farmId}/sdb/eliminar/${data.connection_data.usuario_id}`;
                        body = { esta_habilitado: false };
                        break;
                    case "API_SELFMANAGED":
                    case "API":
                        url = `/farms/${farmId}/integrador/${data.connection_data.distribuidor_id}/desconectarIntegrador/${data.connection_data.usuario_id}`;
                        body = { esta_conectado: false };
                        break;
                    case "SEAT":
                        url = `/marketplace/${farmId}/disable-seat`;
                        body = { billing_servicio_id: data.connection_data.servicio_id };
                        break;
                    default:
                        if (data.tipo_formulario.startsWith("EXT")){
                            url = `/external/${farmId}/disable-provider`;
                            if (data.tipo_formulario === "EXT_CERES"){
                                body = { externalProviderId: data.connection_data.external_provider_id, config: data.connection_data.config };
                            }else if(data.tipo_formulario === "EXT_JHON_DEERE"){
                                body = { id: data.connection_data.id, type:"JOHNDEERE" };
                            } else {
                                body = { externalProviderId: data.connection_data.external_provider_id };
                            }
                        }
                        break;
                }
                return { url, body };
            },
            skipCostStep: true,
            skipReviewStep: true,
            hideStepper: true,
            confirmButtonLabel: t("sass.desconectar"),
            returnOnSuccess: true,
            steps: [
                {
                    label: t("sass.desconectar"),
                    inputs: [
                        {
                            component: "info",
                            content: () => {
                                return (
                                    <div className="mt-2 mb-2" style={{ fontWeight: 500 }}>
                                        {t("sdb.eliminar.msg")}
                                    </div>
                                );
                            }
                        },
                    ],
                },
            ],
        };
    }

    /**
   * @returns {{ connection_id: string, label: string }}
  */
    static resolveConnectionIdentifier(connection, t) {
        if (connection?.tipo_formulario.startsWith("EXT_")){
            if (connection?.tipo_formulario === "EXT_JHON_DEERE"){
                return {
                    connection_id: connection.connection_id,
                    label: connection?.connection_data?.assets?.orgName,
                    orgId:connection?.connection_data?.assets?.orgId,
                    sectores:connection?.connection_data?.assets?.sector?.map(s => s.id),
                    equipos:connection?.connection_data?.assets?.equipo?.map(s => s.id)
                };
            }
            else {
                const connectionLabel = connection.connection_data?.tipo === "UFL" ?
                    UFL.getStationName(connection.connection_data?.config?.stationId) :
                    connection.connection_data?.nombre_sector;
                return {
                    connection_id: connection.connection_id,
                    label: connectionLabel ??
                connection.connection_data?.config?.device_id ??
                connection.connection_data?.config?.stationId ??
                connection.connection_data?.config?.device_sn ??
                connection.connection_data?.config?.logger_name ??
                connection.connection_data?.config?.plot_id ??
                connection.connection_data?.tipo
                };
            }
        } else if (["SEAT","FEATURE","REQUEST", "API_SDB"].includes(connection?.tipo_formulario)){
            return {
                connection_id: connection.connection_id,
                seat_cant: connection.connection_data?.config?.cant,
                label: ""
            };
        } else if (["API_SELFMANAGED", "API"].includes(connection?.tipo_formulario)) {
            return {
                connection_id: connection.connection_id,
                label: `${connection.connection_data?.nombre} (${t("sass.tipoUsuario."+connection.connection_data?.tipousuario_id, Integrator.resolveOldIntegratorAccessType(connection, t))})`
            };
        }

    }
}
